import React, { useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

function useQuery() {
  return useMemo(() => new URLSearchParams(window.location.search), []);
}

const mapRedirect = (path) => {
  switch (path) {
    case '/super/dashboard':
      return '/dashboard/super-admin';
    case '/admin/dashboard':
      return '/dashboard/admin';
    case '/viewer/home':
      return '/dashboard/viewer';
    default:
      return null;
  }
};

export default function OAuthCallback() {
  const q = useQuery();
  const navigate = useNavigate();

  useEffect(() => {
    const error = q.get('error');
    const token = q.get('token');
    const redirect = q.get('redirect');

    if (error) {
      // Send user to login with error info
      navigate(`/login?error=${encodeURIComponent(error)}`);
      return;
    }

    if (token) {
      localStorage.setItem('token', token);
      // Optionally, fetch /me to populate user
      // Defer until app loads a protected route to keep it simple
      const target = mapRedirect(redirect) || '/dashboard/viewer';
      navigate(target, { replace: true });
      return;
    }

    navigate('/login', { replace: true });
  }, [q, navigate]);

  return (
    <div className="auth-wrapper">
      <div className="auth-card">
        <h1>Signing you in…</h1>
        <p className="subtle">Please wait while we complete authentication.</p>
      </div>
    </div>
  );
}
